<template>
    <div>
      <div>
        <h4>This action requires to enter your password!</h4>
        <p>Please enter your password in order to connect your account.</p>
      </div>
      <b-form method="post" :action="`/accounts/authentication/finish-connecting-spl-login/${tuid}`">
        <b-form-group label="Enter your password" aria-label="Verification code">
          <b-form-input name="csrfmiddlewaretoken" hidden :value="csrftoken"></b-form-input>
          <b-form-input name="password" type="password" placeholder="xxxxxx" aria-label="Enter your password"></b-form-input>
          <b-button type="submit" variant="info" class="mt-2">Connect Account</b-button>
        </b-form-group>
      </b-form>
  
      <div class="d-flex flex-column align-items-end">
        <small><a href='/'>Go back to profile page</a></small>
      </div>
    </div>
  </template>
  
  <script>
    import { suppliosApi } from '@/js/api-service';
    import { errorHandling } from '@/js/custom-vue-mixins';
  
    export default {
      name: 'VerifyUserPasswordToConnectSplLogin',
      components: {},
      mixins: [errorHandling],
      props: {
        csrftoken: {
          type: String,
          required: true,
        },
        tuid: {
          type: String,
          required: true,
        },
        nexturl: {
          type: String,
          required: false,
          default: '',
        },
      },
      computed: {
        redirectUrl: function () {
          return this.nexturl && this.nexturl !== '' ? `?next=${this.nexturl}` : '';
        }, 
      },
      mounted: function() {
          console.log('nexturl', this.redirectUrl)
          suppliosApi.auth.getLoginMethods();
      },
    };
  </script>
  
  <style lang='scss' scoped>
      .resend_a:hover {
          color: #007bff;
          cursor: pointer;
      }
  </style>
  